'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _commonFormsy = require('../common-formsy');

var _common = require('../common');

var _SmartBool = require('../../utils/SmartBool');

var _SmartBool2 = _interopRequireDefault(_SmartBool);

var _FollowUpDateInput = require('./FollowUpDateInput');

var _FollowUpDateInput2 = _interopRequireDefault(_FollowUpDateInput);

var _UpdateRequestButton = require('./UpdateRequestButton');

var _UpdateRequestButton2 = _interopRequireDefault(_UpdateRequestButton);

var _UpdateRequestEmailModule = require('./UpdateRequestEmailModule');

var _UpdateRequestEmailModule2 = _interopRequireDefault(_UpdateRequestEmailModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var NoUpdateForm = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(NoUpdateForm, _Component);

  function NoUpdateForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NoUpdateForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NoUpdateForm.__proto__ || Object.getPrototypeOf(NoUpdateForm)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'trackingFollowUpDate', _descriptor, _this), _initDefineProp(_this, 'isSubmitting', _descriptor2, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NoUpdateForm, [{
    key: 'handleSubmit',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(formData) {
        var _props, attribute, onSubmit, body, response_email, bodyBase, bodyFull, submitData;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, attribute = _props.attribute, onSubmit = _props.onSubmit, body = formData.body, response_email = formData.response_email, bodyBase = body || '', bodyFull = response_email ? bodyBase.concat('\n\nEmail: ' + response_email) : bodyBase, submitData = _extends({}, formData, { body: bodyFull, tracking_attributes: [attribute], unappendedBody: body });


                this.isSubmitting.setTrue();
                _context.next = 4;
                return onSubmit(submitData);

              case 4:
                this.isSubmitting.setFalse();

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleSubmit(_x) {
        return _ref2.apply(this, arguments);
      }

      return handleSubmit;
    }()
  }, {
    key: 'handleTrackingFollowUpDate',
    value: function handleTrackingFollowUpDate(val) {
      this.trackingFollowUpDate = val;
    }
  }, {
    key: 'render',
    value: function render() {
      var followUpText = this.props.followUpText;


      return _react2.default.createElement(
        _commonFormsy.Form,
        { className: 'modal-form-style', onValidSubmit: this.handleSubmit },
        _react2.default.createElement(_commonFormsy.Textarea, { label: 'Add a note (optional)', name: 'body' }),
        _react2.default.createElement(_common.Spacer, null),
        _react2.default.createElement(_FollowUpDateInput2.default, {
          label: followUpText,
          onChange: this.handleTrackingFollowUpDate,
          value: this.trackingFollowUpDate
        }),
        _react2.default.createElement(_common.Spacer, { large: true }),
        _react2.default.createElement(_UpdateRequestEmailModule2.default, null),
        _react2.default.createElement('hr', null),
        _react2.default.createElement(_UpdateRequestButton2.default, { disabled: this.isSubmitting.isTrue })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return NoUpdateForm;
}(_react.Component), _class3.propTypes = {
  followUpText: _propTypes2.default.string.isRequired,
  fromTask: _propTypes2.default.bool,
  last_tracking_status: _propTypes2.default.string,
  onSubmit: _propTypes2.default.func.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'trackingFollowUpDate', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'isSubmitting', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _SmartBool2.default();
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'handleTrackingFollowUpDate', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'handleTrackingFollowUpDate'), _class2.prototype)), _class2)) || _class) || _class;

var _default = NoUpdateForm;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(NoUpdateForm, 'NoUpdateForm', '/app/src/components/page-tasks/NoUpdateForm.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-tasks/NoUpdateForm.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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